export const setClarity = (key: string, value: any) => {
  if (typeof window.clarity === 'function') {
    window.clarity('set', key, value)
  }
}
